"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../../../theme"));
const useStylesAddedGiftCard = (0, _core.makeStyles)({
  addedGiftCards: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '30px',
    paddingBottom: '30px',
    color: _theme.default.palette.grayScale.dark,
    [_theme.default.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingBottom: '0'
    },
    '&:last-child': {
      paddingBottom: '0'
    }
  },
  addedGiftCardsWrapper: {
    [_theme.default.breakpoints.down('lg')]: {
      maxWidth: '65%'
    },
    [_theme.default.breakpoints.down('md')]: {
      maxWidth: '70%'
    },
    [_theme.default.breakpoints.down('sm')]: {
      maxWidth: '100%'
    }
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginLeft: '15px',
    [_theme.default.breakpoints.down('sm')]: {
      marginTop: '30px',
      flexDirection: 'row-reverse'
    },
    '& button': {
      height: '20px'
    },
    '& button span': {
      fontSize: _theme.default.typography.pxToRem(16)
    }
  },
  addedGiftCardTitle: {
    fontSize: _theme.default.typography.pxToRem(18),
    lineHeight: '22px',
    [_theme.default.breakpoints.down('sm')]: {
      fontSize: _theme.default.typography.pxToRem(16)
    }
  },
  addedGiftCardRemainingBalance: {
    fontSize: _theme.default.typography.pxToRem(16),
    lineHeight: '20px',
    marginTop: '10px',
    fontStyle: 'italic'
  },
  addedGiftCardMessage: {
    marginTop: '30px',
    color: _theme.default.palette.green,
    fontSize: _theme.default.typography.pxToRem(16),
    lineHeight: '24px',
    fontFamily: _theme.default.typography.proxima.semiBold,
    [_theme.default.breakpoints.down('sm')]: {
      marginTop: '20px'
    }
  },
  addedGiftCardBlueText: {
    color: _theme.default.palette.primary.main,
    fontFamily: _theme.default.typography.proxima.semiBold
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontSize: _theme.default.typography.pxToRem(14),
    '& > button': {
      paddingLeft: '15px',
      height: '24px'
    }
  },
  removeDownBtn: {
    [_theme.default.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  removeTopBtn: {
    display: 'none',
    [_theme.default.breakpoints.down('sm')]: {
      display: 'block',
      marginTop: '20px'
    }
  },
  removeMarginTop: {
    [_theme.default.breakpoints.down('sm')]: {
      marginTop: '0'
    }
  }
});
var _default = exports.default = useStylesAddedGiftCard;